export const discountGroupPermissionsConst = {
  view: {
    value: "view_discountgroup",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu grup rabatowych!",
  },
  add: {
    value: "add_discountgroup",
    errorMsg: "Użytkownik nie ma uprawnień do dodania grup rabatowych!",
  },
  update: {
    value: "change_discountgroup",
    errorMsg: "Użytkownik nie ma uprawnień do edycji grup rabatowych!",
  },
  delete: {
    value: "delete_discountgroup",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania grup rabatowych!",
  },
};
